import 'react-phone-number-input/style.css'

import { useAuth0 } from '@auth0/auth0-react'
import { Button } from '@cleanlab/design-system/components'
import { IconWarning } from '@cleanlab/design-system/icons'

import ActivateAccount from '@/components/ActivateAccount/ActivateAccount'
import ConfirmEmail from '@/components/ConfirmEmail/ConfirmEmail'
import { LoadingScreen } from '@/components/LoadingScreen/LoadingScreen'
import { useUser } from '@/providers/account/UserContextProvider'

export const AccountVerificationGuard = ({ children }: { children: React.ReactNode }) => {
  const { userData, isLoading, error } = useUser()
  const { email_verified: emailVerified, is_account_activated: isAccountActivated } = userData ?? {}
  const { logout } = useAuth0()

  if (isLoading || !userData) {
    return <LoadingScreen />
  }
  if (!userData || error) {
    return (
      <div className="flex h-full items-center justify-center p-6">
        <div className="flex flex-col items-center gap-5">
          <IconWarning className="text-red-600" size={48} />
          <p className="type-display-100 font-bold">Error retrieving your account</p>
          <p className="type-body-100">Please log out and try again, or refresh the page.</p>
          <Button
            className="mt-4"
            variant="critical"
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          >
            Log out
          </Button>
        </div>
      </div>
    )
  }
  if (!isAccountActivated) {
    return (
      <div className="mx-auto w-full max-w-[720px] px-6 py-8">
        <ActivateAccount />
      </div>
    )
  }
  if (!emailVerified) {
    return (
      <div className="mx-auto flex w-full max-w-[720px] items-center px-6 py-8">
        <ConfirmEmail />
      </div>
    )
  }
  return <>{children}</>
}
